import { GENERAL_PURPOSE_SSD_GP3 } from 'pages/provisioning/aws/ec2/constant';
import { AwsEC2CatalogDefinitionId, AwsRHELCBCatalogDefinitionId } from 'utils/catalogDefinitionId';

export const formOrderObjFromCart = (data = null) => {
    const dataDisks = data?.itemDetail?.catalogService?.catalogConfig?.diskDefinitions || null;
    const os = data?.itemDetail?.catalogService?.catalogConfig?.os || null;
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    const entityDetails = data?.itemDetail?.entityDetails || null;
    const getDataDisks = () => {
        let modifiedDisks = [];
        modifiedDisks = dataDisks?.map((item) => {
            const defaultDiskType = GENERAL_PURPOSE_SSD_GP3;
            const defaultFsType = os?.osType === 'Windows' ? 'NTFS' : 'ext4';
            return {
                diskType: item?.diskType || defaultDiskType,
                diskDriveLetter: item?.diskDriveLetter || '',
                mountPoint: item?.mountPoint || '',
                fsType: item?.fsType || defaultFsType,
                diskSizeInGib: item?.diskSizeInGib,
                diskTypeCode: item?.diskTypeCode || '',
            };
        });
        return modifiedDisks;
    };
    return {
        appProfile: catalogConfig?.applicationService || null,
        sector: catalogConfig?.sector || null,
        environment: catalogConfig?.environment || null,
        department: catalogConfig?.department || null,
        appRegion: catalogConfig?.applicationRegion || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        ...(catalogConfig?.environment === 'Production' && {
            isHighAvailability: catalogConfig?.highAvailability === true ? 'yes' : 'no',
            isEDRSEnabled: catalogConfig?.edrsEnabled === true ? 'yes' : 'no',
        }),
        sku: catalogConfig?.osImage || null,
        osImage: catalogConfig?.osImage || null,
        awsAccountId: catalogConfig?.accountId || null,
        vpcId: catalogConfig?.vpcId || null,
        availabilityZone: catalogConfig?.awsAvailabilityZone || null,
        subnetId: catalogConfig?.subnetId || null,
        subnetName: catalogConfig?.subnetName || null,
        ec2InstanceType: catalogConfig?.instanceType,
        quantity: data?.itemDetail?.catalogService?.quantity,
        ...(catalogConfig?.microServiceId && {
            microService: catalogConfig?.microServiceName,
            microServiceDetails: {
                label: catalogConfig?.microServiceName,
                value: catalogConfig?.microServiceName,
                data: {
                    microserviceId: catalogConfig?.microServiceId,
                    microserviceName: catalogConfig?.microServiceName,
                    number: catalogConfig?.microServiceNumber,
                },
            },
        }),
        domain: catalogConfig?.domain,
        appTier: environmentDetails?.applicationTier || null,
        appTierCode: environmentDetails?.appTierCode || null,
        billingEntity: catalogConfig?.billingEntity || null,
        ...(catalogConfig?.adGroup && { adGroup: catalogConfig?.adGroup }),
        ...(catalogConfig?.samAccountId && { samAccountId: catalogConfig?.samAccountId }),
        ...([...AwsRHELCBCatalogDefinitionId]?.includes(data?.itemDetail?.catalogService?.catalogServiceCode) && {
            customBuild: catalogConfig?.customBuildType || null,
        }),
        // Add data disks configuration
        dataDisksCount: dataDisks?.length || 0,
        dataDisks: getDataDisks() || [],
        serverRefresh: catalogConfig?.serverRefresh === true ? 'yes' : 'no',
        ...(catalogConfig?.serverRefresh && {
            retiringServerName: catalogConfig?.retiringServerName || null,
            retiringServerSysId: catalogConfig?.retiringServerSysId || null,
            scheduledRetirement: catalogConfig?.scheduledRetirement || null,
            disposalReason: catalogConfig?.disposalReason || null,
        }),
        osType: os?.osType || 'Windows',
        vcpus: catalogConfig?.vcpus || null,
        vcpusCoreCount: catalogConfig?.vcpusCoreCount || null,
        memoryGiB: catalogConfig?.memoryGiB || null,
        backupTier: environmentDetails?.backupTier || null,
        drPriority: environmentDetails?.drPriority || null,
        metallic: environmentDetails?.metallic || null,
        ...(catalogConfig?.componentName && { componentName: catalogConfig?.componentName }),
        ...(catalogConfig?.securityGroupId && {
            componentNameDetails: {
                ACSG_GroupId: catalogConfig?.securityGroupId,
                ACSG_ComponentName: catalogConfig?.componentName,
                ACSG_Name: catalogConfig?.securityGroupName || null,
            },
        }),
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        entityDetails: { ...entityDetails },
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const dataDisks = catalogConfig?.diskDefinitions || [];
    const os = catalogConfig?.os || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    const entityDetails = data?.entityDetails || null;
    const getDataDisks = () => {
        let modifiedDisks = [];
        modifiedDisks = dataDisks?.map((item) => {
            const defaultDiskType = GENERAL_PURPOSE_SSD_GP3;
            const defaultFsType = os?.osType === 'Windows' ? 'NTFS' : 'ext4';
            return {
                diskType: item?.diskType || defaultDiskType,
                diskDriveLetter: item?.diskDriveLetter || '',
                mountPoint: item?.mountPoint || '',
                fsType: item?.fsType || defaultFsType,
                diskSizeInGib: item?.diskSizeInGib,
                diskTypeCode: item?.diskTypeCode || '',
            };
        });
        return modifiedDisks;
    };
    return {
        appProfile: catalogConfig?.applicationService || null,
        sector: catalogConfig?.sector || null,
        environment: catalogConfig?.environment || null,
        department: catalogConfig?.department || null,
        appRegion: catalogConfig?.applicationRegion || null,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter },
        }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        ...(catalogConfig?.environment === 'Production' && {
            isHighAvailability: catalogConfig?.highAvailability === true ? 'yes' : 'no',
            isEDRSEnabled: catalogConfig?.edrsEnabled === true ? 'yes' : 'no',
        }),
        sku: catalogConfig?.osImage || null,
        osImage: catalogConfig?.osImage || null,
        awsAccountId: catalogConfig?.accountId || null,
        vpcId: catalogConfig?.vpcId,
        availabilityZone: catalogConfig?.awsAvailabilityZone || null,
        subnetId: catalogConfig?.subnetId || null,
        subnetName: catalogConfig?.subnetName || null,
        ec2InstanceType: catalogConfig?.instanceType,
        quantity: catalog?.quantity,
        domain: catalogConfig?.domain,
        adGroup: catalogConfig?.adGroup,
        ...(catalogConfig?.microServiceId && {
            microService: catalogConfig?.microServiceName,
            microServiceDetails: {
                label: catalogConfig?.microServiceName,
                value: catalogConfig?.microServiceName,
                data: {
                    microserviceId: catalogConfig?.microServiceId,
                    microserviceName: catalogConfig?.microServiceName,
                    number: catalogConfig?.microServiceNumber,
                },
            },
        }),
        appTier: environmentDetails?.applicationTier || null,
        appTierCode: environmentDetails?.appTierCode || null,
        billingEntity: catalogConfig?.billingEntity || null,
        ...(catalogConfig?.adGroup && { adGroup: catalogConfig?.adGroup }),
        ...(catalogConfig?.samAccountId && { samAccountId: catalogConfig?.samAccountId }),
        ...([...AwsRHELCBCatalogDefinitionId]?.includes(catalog?.catalogServiceCode) && {
            customBuild: catalogConfig?.customBuildType || null,
        }),
        // Add data disks configuration
        dataDisksCount: dataDisks?.length || 0,
        dataDisks: getDataDisks() || [],
        serverRefresh: catalogConfig?.serverRefresh === true ? 'yes' : 'no',
        ...(catalogConfig?.serverRefresh && {
            retiringServerName: catalogConfig?.retiringServerName || null,
            retiringServerSysId: catalogConfig?.retiringServerSysId || null,
            scheduledRetirement: catalogConfig?.scheduledRetirement || null,
            disposalReason: catalogConfig?.disposalReason || null,
        }),
        osType: os?.osType || 'Windows',
        vcpus: catalogConfig?.vcpus || null,
        vcpusCoreCount: catalogConfig?.vcpusCoreCount || null,
        memoryGiB: catalogConfig?.memoryGiB || null,
        backupTier: environmentDetails?.backupTier || null,
        drPriority: environmentDetails?.drPriority || null,
        metallic: environmentDetails?.metallic || null,
        ...(catalogConfig?.componentName && { componentName: catalogConfig?.componentName }),
        ...(catalogConfig?.securityGroupId && {
            componentNameDetails: {
                ACSG_GroupId: catalogConfig?.securityGroupId,
                ACSG_ComponentName: catalogConfig?.componentName,
                ACSG_Name: catalogConfig?.securityGroupName || null,
            },
        }),
        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        entityDetails: { ...entityDetails },
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};
export const resetOrder = {
    // Application Section
    appProfile: null,
    drPriority: null,
    entityDetails: null,
    sector: null,
    sectorDetail: null,
    department: null,
    departmentDetail: null,
    selectedDepartmentOption: null,
    appRegion: null,
    environment: null,
    landingZoneDetails: null,
    hCode: null,
    hCodeDetails: null,
    appOwner: null,
    appOwnerDetails: null,
    appTier: null,
    appTierCode: null,
    microService: null,
    microServiceDetails: null,

    // Resource Section
    osImage: null,
    awsAccount: null,
    awsAccountId: null,
    vpcId: null,
    subnetId: null,
    securityGroup: null,
    availabilityZone: null,
    ec2InstanceType: null,
    quantity: 1,
    maxDataDiskCount: 8,
    dataDisksCount: null,
    dataDisks: [],
    defaultDataDisks: [],
    vmType: 'Windows',
    retiringServerSysId: null,
    retiringServerName: null,
    disposalReason: null,
    scheduledRetirement: null,
    serverRefresh: 'no',
    billingEntity: null,
    billingEntityDetails: null,
    vcpus: null,
    vcpusCoreCount: null,
    memoryGiB: null,

    // Application Component Security Group Section
    componentName: null,
    componentNameDetails: null,

    // Access Management Section
    domain: null,
    adGroup: null,
    adous: null,
    adousDetails: null,
    samAccountId: null,

    tags: [],
    estimatedCost: {
        details: [],
        qty: null,
        totalOneTimeCost: {
            frequency: 'one time',
            estCost: null,
            currency: 'USD',
        },
        totalRecurringCost: {
            frequency: 'monthly',
            estCost: null,
            currency: 'USD',
        },
        notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
    },
    placeNewOrder: new Date(),
    validationStatus: 'clearValidation',
    isTouched: false,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isTagOpen: false,
    isApplicationOpen: false,
    isSubmitOrderSuccess: false,
    isUpdatedToCart: false,
    isCostSplitOpen: false,
    isDiskOpen: false,
    isDataDisk: { isOpen: false, newDataDiskCount: 0, deleteCount: 0 },
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'monthly',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const getDataDiskSize = (data) => {
    const size = data?.values[0]?.possibleValues || [];
    return size.map((item) => item);
};

export const isValidMountPoint = (disableField, mountPt) => {
    let result = true;
    if (!disableField) {
        // result = mountPt?.charAt(0) === '/';
        result = /^\/(?:[a-zA-Z0-9_-]+\/?)*$/?.test(mountPt);
    }
    return result;
};

export const ispgthanaFormValid = (dataDisks, reservedPaths) => {
    let errorCount = 0;
    let isDataDiskValid = false;
    if (dataDisks?.length) {
        dataDisks?.forEach((disk) => {
            if (
                !(
                    (disk?.disableFields &&
                        disk.diskSizeInGib !== '' &&
                        disk.diskType !== '' &&
                        disk.diskCount !== '' &&
                        disk.diskCount !== 0 &&
                        (disk?.diskTier && disk?.diskTier !== null ? /^[0-9]+$/.test(disk.diskCount) : true) &&
                        disk.diskCount !== '0' &&
                        disk.totalSize !== undefined &&
                        disk.totalSize !== '') ||
                    (!disk?.disableFields &&
                        disk.diskSizeInGib !== '' &&
                        disk.diskType !== '' &&
                        disk.mountPoint !== '' &&
                        disk.mountPoint !== undefined &&
                        disk.fsType !== '' &&
                        !reservedPaths?.includes(disk.mountPoint) &&
                        isValidMountPoint(disk?.disableFields, disk?.mountPoint))
                )
            ) {
                // eslint-disable-next-line no-plusplus
                errorCount++;
            }
        });
    }
    isDataDiskValid = errorCount === 0;
    return isDataDiskValid;
};

export const isMountPointDuplicate = (dataDisks) => {
    const mountPointsArray = dataDisks?.filter((disk) => disk?.mountPoint && disk?.mountPoint)?.map((d) => d?.mountPoint) || [];
    return new Set(mountPointsArray)?.size !== mountPointsArray?.length;
};

export const checkMountPointExists = (mountPoint, disableFields = false, reservedPaths = []) => {
    if (!disableFields) {
        const mountPoints = reservedPaths || [];
        // const expression=/^\/[a-zA-Z][a-zA-Z0-9_-]*$/;
        let ValidMountPoint = { shhowMessage: false, message: null };
        if (mountPoint && (mountPoint !== '' || mountPoint !== null)) {
            if (!/^\/(?:[a-zA-Z0-9_-]+\/?)*$/?.test(mountPoint)) {
                ValidMountPoint = { shhowMessage: true, message: 'should start with / followed by alphabet ' };
            } else if (mountPoints.indexOf(mountPoint) > -1) {
                ValidMountPoint = {
                    shhowMessage: true,
                    message: `following paths are reserved
                ${reservedPaths?.join(', ')}`,
                };
            } else {
                ValidMountPoint = { shhowMessage: false, message: null };
            }
        }
        return ValidMountPoint;
    }
    return '';
};

export const costPayload = ({ order = [], catalogCode, defaultOsDT }) => {
    const isWindows = [...AwsEC2CatalogDefinitionId]?.includes(catalogCode);

    const dataDisks = order.dataDisks.map((disk) => {
        const { mountPoint, diskDriveLetter, fsType, diskType, diskTypeCode, ...rest } = disk;
        let code = defaultOsDT?.osDiskTypeCode;
        const findDTOptions = defaultOsDT?.diskTypeOptions?.find((diskFind) => diskFind.name === disk.diskType);
        if (findDTOptions) {
            code = findDTOptions?.code;
        }
        return { ...rest, diskType: code };
    });
    const payload = {
        catalogServiceCode: catalogCode,
        quantity: order?.quantity,
        catalogConfig: {
            instanceType: order?.ec2InstanceType,
            ...(order?.isEDRSEnabled === 'yes' && { edrsEnabled: true }),
            os: {
                osType: isWindows ? 'Windows' : 'Linux',
            },
            environmentDetails: {
                region: order?.landingZoneDetails?.region,
                environment: order?.environment,
            },
            diskDefinitions: dataDisks,
        },
    };
    return payload;
};

export const getOsType = (isWindows) => {
    return isWindows ? 'Windows' : 'Linux';
};

// Regex pattern for project name validation
export const PROJECT_NAME_REGEX = /^[A-Za-z0-9]{3,14}$/;

export const validateProjectName = (projectName) => {
    if (!projectName || projectName === '' || projectName === undefined) {
        return true;
    }
    return PROJECT_NAME_REGEX.test(projectName);
};

export const getRdsLabel = (catalogCode) => {
    switch (catalogCode) {
        case 'AWSWINVM2022':
            return 'Windows 2022';
        case 'AWSWINVM2019':
            return 'Windows 2019';
        case 'AWSWINVM2025':
            return 'Windows 2025';
        case 'AWSRHELVM':
            return 'RHEL';
        case 'AWSSLESVM':
            return 'SLES';
        case 'AWSRHELCBVM':
            return 'RHEL Custom Build';
        default:
            return 'OEL';
    }
};
